import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoningruilAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M6.99 36c0-3.31 2.69-6 6-6s6 2.69 6 6M21 36c0-3.31 2.69-6 6-6s6 2.69 6 6"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M12.99 30a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M27 30a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M25.66 14.1a3.796 3.796 0 0 0 0-5.38c-1.49-1.48-3.9-1.49-5.38 0-1.17 1.17-1.4 2.91-.73 4.32l-3.75 3.75-.9-.9-1.79 1.79 2.69 2.69.9-.9.9-.9 3.75-3.75c1.41.67 3.15.44 4.32-.73zm-3.59-1.79c-.5-.5-.5-1.3 0-1.79s1.3-.5 1.79 0 .5 1.3 0 1.79-1.3.5-1.79 0"
      clipRule="evenodd"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M10.42 17c1.27 4.06 5.06 7 9.54 7s8.27-2.94 9.54-7M29.5 11c-1.27-4.06-5.06-7-9.54-7s-8.27 2.94-9.54 7"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="m13.49 9.1-3.05 1.91-.59-3.55M26.48 18.85l3.05-1.91.59 3.56"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoningruilAanvragen);

export default ForwardRef;
